import { Injectable } from "@angular/core";
import { Resolve } from "@angular/router";
import { ProcessElementsResource } from "core/stages-client";
import { ViewService } from "core/view.service";
import { ComplianceProcessAssociationStore } from "process/compliance/associations/compliance-process-association-store.logic";
import { AssociationService } from "process/associations/association.service";

@Injectable({ providedIn: "root" })
export class ComplianceProcessAssociationStoreResolver implements Resolve<ComplianceProcessAssociationStore> {
	constructor(
		private viewService: ViewService,
		private associationService: AssociationService,
		private processElementsResource: ProcessElementsResource,
	) {}

	resolve(): ComplianceProcessAssociationStore {
		return new ComplianceProcessAssociationStore(
			this.viewService,
			this.associationService,
			this.processElementsResource,
		);
	}
}
